<template>
	<b-card class="project-tile" no-body>
		<b-card-body>
			<div class="d-flex w-100 justify-content-between">
				<b-card-title>{{ project.name }}</b-card-title>
				<small>{{ date_range }}</small>
			</div>
			<b-card-sub-title>{{ project.customer.name }}
				<div v-if="project.locked" class="locked d-inline float-right">
					<b-icon-lock-fill></b-icon-lock-fill>
				</div>
			</b-card-sub-title>
		</b-card-body>

		<a class="stretched-link" v-bind:href="`/projects/${project.id}/details`" v-on:click.prevent="onClick"></a>
	</b-card>
</template>

<script>
import moment from 'moment'

export default {
	name: 'ProjectTile',

	props: {
		value: Object,
	},

	computed: {
		date_range () {
			if (this.value.start_date && this.value.end_date) {
				return moment(this.value.start_date).format('M/D') + ' - ' + moment(this.value.end_date).format('M/D/Y')
			} else if (this.value.start_date && !this.value.end_date) {
				return moment(this.value.start_date).format('M/D/Y')
			} else if (!this.value.start_date && this.value.end_date) {
				return moment(this.value.end_date).format('M/D/Y')
			} else {
				return ''
			}
		},

		prizes () {
			return Number(this.value.number_prizes).toLocaleString()
		},

		products () {
			return Number(this.value.number_products).toLocaleString()
		}
	},

	data () {
		return {
			project: this.value
		}
	},

	methods: {
		onClick () {
			this.$axios.post('/projects/access', { id: this.value.id })
				.then(() => {
					this.$router.push(`/projects/${this.value.id}/details`)
				})
		}
	}
}
</script>

<style>
.locked {
	position: relative;
	bottom: 0;
	right: 0;
}
</style>
